import { Dropdown } from 'antd';
import { MenuProps } from 'antd/lib';
import { TURN_SORT_BY } from 'features/turn/services/constants';
import { turnManualActions } from 'features/turn/services/reducers';
import { turnManualSelectors } from 'features/turn/services/selectors';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import ic_sort from './ic-sort-by.svg';
import ic_refresh from './ic-refresh.svg';
import { turnManualAPIActions } from 'features/turn/services/actions';
import { useSetLoadingPage } from 'services/UI/LoadingPage';

const TurnSort = () => {
  const allSetting = shopSelectors.data.allSetting();
  const dispatch = useAppDispatch();
  const sort = turnManualSelectors.sort();
  const setLoadingPage = useSetLoadingPage();
  const setSort = (value: string) => dispatch(turnManualActions.setSort(value as TURN_SORT_BY));
  const onClickMenuItem = (key: string) => {
    if (sort == key) {
      return;
    }
    setSort(key);
  };

  const filterItems: MenuProps['items'] = [
    {
      key: TURN_SORT_BY.CLOCK_IN,
      label: (<a onClick={(e) => {
        e.preventDefault();
        onClickMenuItem(TURN_SORT_BY.CLOCK_IN);
      }}>Clock In</a>),
    },
    {
      key: TURN_SORT_BY.TURN,
      label: (<a onClick={(e) => {
        e.preventDefault();
        onClickMenuItem(TURN_SORT_BY.TURN);
      }}>Turn</a>),
    },
  ];

  const onRefresh = () => {
    setLoadingPage(true);
    dispatch(turnManualAPIActions.init());
    setTimeout(() => {
      setLoadingPage(false);
    }, 500);
  };

  return (
    <Dropdown
      menu={{
        items: filterItems,
        selectable: true,
        selectedKeys: sort ? [sort] : [],
      }}
      trigger={['click']}
    >
      <a onClick={(e) => {
        e.preventDefault();
      }}>
        <Filter style={{ width: allSetting?.voiceCallStaff ? '240px' : '165px', gap: 8 }}>
          {/* <Icon type='filter' fill={'#f5767f'} /><span style={{ color: '#f5767f' }}>Turn By</span> */}
          <IconStyled type='button'>
            <img src={ic_sort} alt='sort' />
          </IconStyled>
          <IconStyled className='refresh-icon' type='button' onClick={(e: any) => [e.stopPropagation(), e.preventDefault(), onRefresh()]}>
            <img src={ic_refresh} alt='refresh' />
          </IconStyled>
        </Filter>
      </a>

    </Dropdown>
  );
};

export default TurnSort;

const IconStyled = styled.button`
  display: flex;
  width: 56px;
  height: 56px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid #D2464F;
  background: #FFF;
  &:hover, &:active {
    opacity: 0.8;
    background: #eee;
    cursor: pointer;
  }

  &.refresh-icon {
    border-radius: 4px;
    border: 1px solid #232F3E;
  }
`;

const Filter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex:1;
    span {
       padding-left: 4px;
    }
`;
